<template>
    <section>
        <div class="row">
            <div class="col-12 col-md-4 mb-5" v-for="(altAlan, index) in campaign" :key="index">
                <div class="card">
                    <div class="card-body">
                        <div class="">{{altAlan.to_city_name}}, {{altAlan.to_country_name}}</div>
                        <div class="card-text small">
                            {{altAlan.from_city_name}} ({{altAlan.from_code}}) - {{altAlan.to_city_name}} ({{altAlan.to_code}})
                        </div>
                        <div class="card-text small">
                            {{altAlan.date_label}}
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="">
                                    <div class="price">{{altAlan.price}}₺</div>
                                    <div class="small grey-text">{{altAlan.transfer}}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 text-right">
                                <a class="btn biletbul-bg-blue btn-sm waves-effect waves-light" :href="altAlan.url">Detaylar <mdb-icon icon="angle-double-right" /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from "axios";
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';

    export default {
        name: "altKampanya.vue",
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,

        },
        data: () => ({
            campaign: [],
        }),
        mounted() {

            axios.get("https://www.biletbul.com/backend/public/api/v1/destination/category/4",{
                headers: {

                }
            })
                .then(response => this.campaign=[...response.data.data])
        }
    }
</script>

<style scoped>

</style>